var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-pinch",class:{ loading: _vm.loading }},[_vm._m(0),_vm._v(" "),_c('img',{ref:"image",attrs:{"src":_vm.image},on:{"load":_vm.resizeImage}})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading"},[_c('div',{staticClass:"cr-spinner"})])
}]

export { render, staticRenderFns }